import {Injectable} from '@angular/core';
import {Mutation} from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root',
})
export class DeleteContainerMutation extends Mutation {
  document = gql`
      mutation deleteContainer($id: ID!) {
          deleteContainer(where: {id: $id}) {
              id
          }
      }
  `;
}
